import { Box, Stack } from "@mui/system";
import {
  TextField,
  Typography,
  FormGroup,
  FormControlLabel,
  Checkbox,
  Accordion,
  AccordionSummary,
  AccordionDetails,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { useSelector } from "react-redux";
import { transformFormData } from "../../DataStoreHelpers/dataStoreHelpers";
import { useDispatch } from "react-redux";
import { updateEditableOutputField } from "../../../../../features/dataStoreReqSlice";

const CreateOutput = () => {
  const { createQueryFormDataInput } = useSelector(
    (state: any) => state.dataStoreReq
  );
  const dispatch = useDispatch();

  const transformedInputs = transformFormData(createQueryFormDataInput);

  const editableOutputData = useSelector(
    (state: any) => state.dataStoreReq.editableOutputValues
  );

  const handleOutputChange = (id: number, key: string, value: string) => {
    dispatch(updateEditableOutputField({ id, key, value }));
  };

  return (
    <Box mt={2}>
      <Accordion
        sx={{
          minHeight: "48px",
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: "0px",
          },
        }}
      >
        <AccordionSummary
          sx={{
            minHeight: "48px !important",
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel1-content"
          id="panel1-header"
        >
          <Typography component="span">Input Fields Review</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box
            sx={{
              overflowX: "auto",
              display: "flex",
              scrollbarWidth: "thin",
            }}
          >
            {transformedInputs.map((input: any, i: any) => (
              <Box
                key={i}
                mb={1}
                sx={{
                  minWidth: "100%",
                  borderRight: "1px solid #E0E0E0",
                }}
                mx={1}
              >
                <Stack
                  flexDirection={"row"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                >
                  <Typography component="span">{input.title}</Typography>
                  <FormGroup>
                    <Stack flexDirection={"row"}>
                      {input.fields[4] && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="secondary"
                              checked={input.fields[4].value}
                              size="small"
                              disabled
                            />
                          }
                          label="UNIQ"
                        />
                      )}
                      {input.fields[5] && (
                        <FormControlLabel
                          control={
                            <Checkbox
                              color="secondary"
                              checked={input.fields[5].value}
                              size="small"
                              disabled
                            />
                          }
                          label="Not Mutable"
                        />
                      )}
                    </Stack>
                  </FormGroup>
                </Stack>
                <Grid container spacing={1} mt={1}>
                  {input.fields.map((field: any, index: any) => (
                    <Grid size={4} key={index}>
                      <TextField
                        label={field.label}
                        disabled
                        fullWidth
                        variant="standard"
                        value={field.value}
                        sx={{
                          "& .MuiInput-underline:before": {
                            borderBottomStyle: "none !important",
                          },
                        }}
                      />
                    </Grid>
                  ))}
                  <Grid size={4}>
                    <TextField
                      label={"description"}
                      disabled
                      fullWidth
                      variant="standard"
                      value={input.description}
                      sx={{
                        "& .MuiInput-underline:before": {
                          borderBottomStyle: "none !important",
                        },
                      }}
                    />
                  </Grid>
                </Grid>
              </Box>
            ))}
          </Box>
        </AccordionDetails>
      </Accordion>
      <Accordion
        sx={{
          minHeight: "48px",
          "& .MuiAccordionSummary-content.Mui-expanded": {
            margin: "0px",
          },
        }}
        defaultExpanded
      >
        <AccordionSummary
          sx={{
            minHeight: "48px !important",
          }}
          expandIcon={<ExpandMoreIcon />}
          aria-controls="panel2-content"
          id="panel2-header"
        >
          <Typography component="span">Output Fields Review</Typography>
        </AccordionSummary>
        <AccordionDetails>
          <Box>
            {editableOutputData.map((field: any) => (
              <div key={field.id}>
                <Stack
                  flexDirection={"row"}
                  alignItems={"center"}
                  justifyContent={"space-between"}
                  mt={2}
                >
                  <Typography>{field.name}</Typography>
                  <FormGroup>
                    <Stack flexDirection={"row"}>
                      <FormControlLabel
                        control={<Checkbox color="secondary" disabled />}
                        label="UNIQ"
                      />
                      <FormControlLabel
                        control={<Checkbox color="secondary" disabled />}
                        label="Not Mutable"
                      />
                    </Stack>
                  </FormGroup>
                </Stack>
                <Grid container spacing={2} mt={2}>
                  <Grid size={6}>
                    <TextField
                      id={`${field.id}-title`}
                      label="Title"
                      fullWidth
                      size="small"
                      color="secondary"
                      placeholder="Please enter Title"
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                      value={
                        editableOutputData.find((f: any) => f.id === field.id)
                          ?.title || ""
                      }
                      onChange={(e) =>
                        handleOutputChange(field.id, "title", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid size={6}>
                    <TextField
                      placeholder="Please enter Description"
                      label="Description"
                      fullWidth
                      size="small"
                      color="secondary"
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                      value={
                        editableOutputData.find((f: any) => f.id === field.id)
                          ?.description || ""
                      }
                      onChange={(e) =>
                        handleOutputChange(
                          field.id,
                          "description",
                          e.target.value
                        )
                      }
                    />
                  </Grid>
                </Grid>
                <Grid container spacing={2} mt={2}>
                  <Grid size={3}>
                    <TextField
                      placeholder="Select from list"
                      label="Type"
                      value={field.type}
                      fullWidth
                      size="small"
                      color="secondary"
                      disabled
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                    />
                  </Grid>
                  <Grid size={3}>
                    <TextField
                      placeholder="Select from list"
                      label="Format"
                      fullWidth
                      size="small"
                      color="secondary"
                      disabled
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                      value={""}
                    />
                  </Grid>
                  <Grid size={3}>
                    <TextField
                      id={`${field.id}-order`}
                      label="Order"
                      fullWidth
                      size="small"
                      color="secondary"
                      placeholder="Please enter Order"
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                      value={
                        editableOutputData.find((f: any) => f.id === field.id)
                          ?.order || ""
                      }
                      onChange={(e) =>
                        handleOutputChange(field.id, "order", e.target.value)
                      }
                    />
                  </Grid>
                  <Grid size={3}>
                    <TextField
                      id={`${field.id}-default-value`}
                      label="Default Value"
                      fullWidth
                      size="small"
                      color="secondary"
                      placeholder="Please enter Value"
                      disabled
                      slotProps={{
                        inputLabel: {
                          shrink: true,
                        },
                      }}
                      value={""}
                    />
                  </Grid>
                  <Typography
                    variant="body2"
                    sx={{ fontSize: "12px" }}
                    color="#00000099"
                  >
                    All fields are mandatory.
                  </Typography>
                </Grid>
              </div>
            ))}
          </Box>
        </AccordionDetails>
      </Accordion>
    </Box>
  );
};

export default CreateOutput;
